import { withFeatureFlagService } from '@mews/framework';
import { connectServiceList } from './connectServiceList';
import { ServiceList as ServiceListPure } from './ServiceList';

export const ServiceList = withFeatureFlagService(connectServiceList(ServiceListPure));
